import { motion, useInView } from "framer-motion";
import { useRef, useEffect, useState } from "react";

const stats = [
  { value: 10, label: "DATA\nAPPROVED" },
  { value: 2, label: "DATA\nON PROCESS" },
  { value: 12, label: "DATA\nTOTAL" },
  { value: 24, label: "DATA\nVIEWS" },
];

const CountUp = ({ target, trigger }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!trigger) return;

    let start = 0;
    const duration = 1000;
    const steps = 30;
    const increment = target / steps;
    const stepTime = duration / steps;

    const counter = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target;
        clearInterval(counter);
      }
      setCount(Math.floor(start));
    }, stepTime);

    return () => clearInterval(counter);
  }, [trigger, target]);

  return <>{count}</>;
};

const StatItem = ({ stat, delay }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.5 });

  return (
    <div className="col-6 col-md-3 mb-4" id="data-content">
      <motion.div
        ref={ref}
        id="box-data"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={isInView ? { scale: 1, opacity: 1 } : {}}
        transition={{
          duration: 0.8,
          ease: "easeOut",
          delay: delay,
        }}
      >
        <h1>
          <strong>
            <CountUp target={stat.value} trigger={isInView} />
          </strong>
        </h1>
      </motion.div>
      <div id="data-text" className="mt-2">
        <h5 className="text-uppercase">
          {stat.label.split("\n").map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </h5>
      </div>
    </div>
  );
};

const DataSection = () => {
  return (
    <section id="data" className="py-4.5">
      <div className="container">
        <div className="row text-center justify-content-center">
          {stats.map((stat, idx) => (
            <StatItem key={idx} stat={stat} delay={idx * 0.2} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DataSection;
